import { createTheme, Theme } from '@mui/material/styles';
import { getPalette, getCssVars, ThemeMode, BRAND } from './palette';
import { typography } from './typography';
import { createShadows } from './shadows';
import { getComponents } from './components';

/**
 * Single source of truth for the app theme. Light and dark are produced from the
 * same factories so they can never drift. Component overrides are applied in a
 * second pass so they can read the resolved palette/shadows.
 */
export const createAppTheme = (mode: ThemeMode): Theme => {
  const base = createTheme({
    palette: getPalette(mode),
    typography,
    shape: { borderRadius: 8 },
    shadows: createShadows(mode),
  });

  return createTheme(base, { components: getComponents(base) });
};

export { getCssVars, BRAND };
export type { ThemeMode };
